import { MapSvg } from '@/modules/home/Map';
import { MTypography } from '@/shared/ui/typography';
import { useLayout } from '@/store/api';
import cn from 'classnames';
import { AnimatePresence, Variants, motion } from 'framer-motion';
import { City } from '~shared';
import cls from './center.module.scss';

const TitleVariants: Variants = {
  initial: {
    scale: 1,
    transition: {
      ease: 'easeOut',
      duration: 0.4,
    },
  },
  animate: {
    scale: 1.5,
    color: '#27282C',
    transition: {
      ease: 'easeOut',
      duration: 0.4,
    },
  },
  hover: {
    color: '#27282C',
    transition: {
      ease: 'easeOut',
      duration: 0.4,
    },
  },
};

const DotVariants: Variants = {
  initial: {
    transition: {
      ease: 'easeOut',
      duration: 0.5,
    },
  },
  animate: {
    backgroundColor: '#27282C',
    transition: {
      ease: 'easeOut',
      duration: 0.5,
    },
  },
  hover: {
    backgroundColor: '#27282C',
    transition: {
      ease: 'easeOut',
      duration: 0.5,
    },
  },
};

interface Props {
  currentCenter: City;
  setCurrentCenter: (city: City) => void;
  className?: string;
}

export const CentersMap = ({
  currentCenter,
  setCurrentCenter,
  className,
}: Props) => {
  const { cities } = useLayout();

  const onCityClick = (city: City) => {
    if (currentCenter?.centers![0].address !== city.centers![0].address) {
      setCurrentCenter(city);
    }
  };

  return (
    <div className={cn(className, 'relative h-[426px] w-[818px]')}>
      {cities?.map((item, ind, arr) => {
        return (
          <motion.div
            whileHover="hover"
            initial="initial"
            animate={
              currentCenter?.centers![0].address === item.centers![0].address
                ? 'animate'
                : 'initial'
            }
            key={item.centers![0].address}
            onClick={() => onCityClick(item)}
            className={cn(
              `${cls.centerMark} absolute z-50 flex cursor-pointer flex-col items-center`,
              {
                hidden: ind > 0 && item.title === arr[ind - 1].title,
              },
            )}
            style={{
              top: item.centers![0].placemark!.top,
              left: item.centers![0].placemark!.left,
            }}
          >
            <MTypography
              variants={TitleVariants}
              variant="textM"
              className=" text-gray-2"
            >
              {item.title}
            </MTypography>

            <motion.div
              variants={DotVariants}
              className=" bg-gray-2 h-2 w-2 rounded"
            ></motion.div>
          </motion.div>
        );
      })}

      <div className="absolute left-0 top-0">
        <MapSvg>
          <AnimatePresence mode="wait">
            <motion.radialGradient
              cx={currentCenter?.centers![0].placemark!.cx}
              cy={currentCenter?.centers![0].placemark!.cy}
              id="grad1"
              key={currentCenter?.centers![0].address}
              initial={{ r: '0%' }}
              animate={{
                r: currentCenter ? '20%' : '0%',
                // transition: { delay: 0.3 },
              }}
              exit={{ r: '0%' }}
              transition={{ duration: 0.3 }}
            >
              <stop stopColor="#6DBF5A" offset="0%" />
              <stop stopColor="#6DBF5A" offset="60%" />
              <stop stopColor="#CDD3DE" offset="100%" />
            </motion.radialGradient>
          </AnimatePresence>
        </MapSvg>
      </div>
    </div>
  );
};
